import styled from 'styled-components';

const VCarouselHolder = styled.div`
  margin-top: 40px;
  & div:focus-visible {
    outline: var(--focus-visible-outline);
    outline-offset: 2px;
  }

  * {
    margin: 0;
  }

  h2 {
    margin-bottom: 8px;
    display: inline-block;
    text-transform: uppercase;
    font-size: 18px;
    font-weight: 500;
    color: var(--headings-text-color);
    font-family: var(--font-family-primary);

    @media only screen
    and (min-device-width: 768px)
    and (max-device-width: 1024px)
    and (orientation: landscape)
    and (-webkit-min-device-pixel-ratio: 1) {
      font-size: 15px;
      margin-right: 15px;
    }
  }
  .list-title:focus-visible {
    text-decoration-line: underline;
  }

  a {
    display: inline-block;
    text-decoration: none;

    &:hover {
      color: var(--clr-black);
    }

    img {
      width: 100%;
      height: 65px;
      object-fit: cover;
    }

    &.seeAll-btn {
      width: 100%;
      font-size: 0.9rem;
      color: var(--btn-dark-text-color);
      background-color: var(--btn-dark-bg-color);
      border: 5px solid var(--btn-dark-border-color);
      border-radius: 5px;
      padding: 0.7rem 1.6rem;
      font-size: 0.9rem;
      font-weight: 700;
      letter-spacing: .025em;
      text-align: center;
      cursor: pointer;
      min-width: 110px;
      text-transform: uppercase;
      transition: all .5s ease;

      &:hover,
      &:focus-visible {
        border: 5px solid var(--btn-dark-border-hover-color);
      }
    }
    &.hidden {
      display: none;
    }
  }

  .seeAllTopBtn {
    float: right;
    color: var(--link-text-color);
    cursor: pointer;
    text-decoration: none;
    text-transform: uppercase;

    &:hover {
      color: var(--cat-link-color);

      svg {
        right: 0px;
      }
    }
    &:focus-visible {
      outline: var(--focus-visible-outline);
      outline-offset: 2px;
    }

    svg {
      position: relative;
      margin-left: 15px;
      right: 8px;
      transition: right 0.2s ease-in;
    }
  }

  .latest-container {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(auto, 1fr);
    gap: 8px 0px;
    grid-template-areas:
		"."
		"."
		"."
		"."
		".";
    margin-bottom: 20px;
    border-top: 1px solid var(--border-medium-color);
    padding: 0px;
    padding-top: 15px;

    li {
      list-style: none;
    }

    &__item {
      display: grid;
      grid-template-columns: 115px auto;
      grid-template-rows: 1fr;
      gap: 10px 15px;
      grid-template-areas:
			  ". .";
      padding-bottom: 25px;
      text-decoration: none;
      border-bottom: 1px solid var(--border-medium-color);

      p {
        margin: 0;
        padding: 0;
      }

      &__img {
        position: relative;
        width: 100%;
        &__date-container {
          width: 50%;
          background-color: var(--v-carousel-duration-bg-color);
          opacity: 0.8;
          color: var(--clr-white);
          text-align: center;
          margin-top: -24px;
          float: right;
          font-family: var(--font-family-primary);
          font-size: 13px;
          padding: 2px;
          font-weight: 500;
        }
        & .testFlag {
					position: absolute;
					top: 0;
					background: var(--clr-white);
					border: 1px solid var(--clr-black);
					padding: 2px;
					color: var(--clr-test-flag);
					font-weight: bold;
				}
      }

      &__info {
        &__category {
          color: var(--cat-link-color);
          font-size: 12px !important;
          font-weight: 700;
          text-transform: uppercase;
          margin: 0 0 5px 0 !important;
          &:focus-visible {
            text-decoration-line: underline;
            text-decoration-color: var(--cat-link-color);
            text-decoration-thickness: 2px;
          }
        }

        &__title {
          display: block;
          color: var(--headings-text-color);
          font-size: 14px;
          line-height: 1.2;
          &:hover {
            text-decoration: underline !important;
          }
          &:focus-visible {
            outline: var(--focus-visible-outline);
          }
        }
      }
      & .episode-date {
        font-size: var(--font-size-small-1);
        color: var(--clr-gray);
      }
    }

    &__btns-container {
      display: flex;
      justify-content: center;

      button {
        font-weight: 700;
        padding: 12px 20px;
        vertical-align: middle;
        font-size: 14px;
        color: var(--btn-light-text-color);
        background-color: var(--btn-light-bg-color);
        border-radius: 4px;
        -webkit-transition: all 0.1s ease-in;
        transition: all 0.1s ease-in;
        border: 1px solid var(--btn-light-border-color);
        line-height: 1;
        -webkit-transition: all 0.1s ease-in;
        transition: all 0.1s ease-in;
        margin-right: 10px;
        min-height: 48px;
        cursor: pointer;

        svg {
          padding: 0;
          margin: -2px 8px 0 8px;
          vertical-align: middle;
          line-height: 1;
        }

        &:last-of-type {
          margin-right: 0;
        }

        &:hover,
        &:focus-visible {
          background-color: var(--btn-light-bg-hover-color) !important;
          color: var(--btn-light-text-hover-color) !important;
          transition: all 0.1s ease-in;
        }

        &:disabled {
          opacity: 0.4;
          cursor: no-drop;
        }
        @media only screen and (min-width: 1051px) and (max-width: 1335px) {
          padding: 12px;
        }

      }

    }

  }
`;

export default VCarouselHolder;